function TaskToolbar({ tasksView, onViewChange, onPreset }) {
    return (
        <div className="tasks__toolbar">
            <div className="tasks__views">
                <button
                    type="button"
                    className={tasksView === 'list' ? 'active' : ''}
                    onClick={() => onViewChange('list')}
                >
                    Список
                </button>
                <button
                    type="button"
                    className={tasksView === 'kanban' ? 'active' : ''}
                    onClick={() => onViewChange('kanban')}
                >
                    Канбан
                </button>
            </div>
            <div className="tasks__presets">
                <button type="button" onClick={() => onPreset('creator')}>
                    Мои: постановщик
                </button>
                <button type="button" onClick={() => onPreset('assignee')}>
                    Мои: исполнитель
                </button>
                <button type="button" onClick={() => onPreset('all')}>
                    Все
                </button>
            </div>
        </div>
    );
}

export default TaskToolbar;
